import styled, { css } from 'styled-components';
var Button = styled.button.withConfig({
  displayName: "StyledButton__Button",
  componentId: "ihk487-0"
})(["box-sizing:border-box;display:flex;justify-content:center;align-items:center;cursor:pointer;border-radius:8px;border:none;transition:all 0.3s ease;font-weight:500;font-family:", ";&:hover,&:focus{outline:none;}&:active{transition:all 450ms cubic-bezier(0.23,1,0.32,1) 0ms;}", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth && css(["width:100%;"]);
}, function (_ref3) {
  var isLoading = _ref3.isLoading,
    disabled = _ref3.disabled;
  return (isLoading || disabled) && css(["pointer-events:none;"]);
}, function (_ref4) {
  var theme = _ref4.theme,
    variant = _ref4.variant;
  return variant === 'primary' && css(["color:white;background-color:", ";&:hover:not(:active),&:focus{background-color:", ";}&:active{background-color:", ";}"], theme.colors.green600, theme.colors.green700, theme.colors.green900);
}, function (_ref5) {
  var theme = _ref5.theme,
    variant = _ref5.variant,
    disabled = _ref5.disabled;
  return variant === 'primary' && disabled && css(["background-color:", ";"], theme.colors.gray600);
}, function (_ref6) {
  var theme = _ref6.theme,
    variant = _ref6.variant;
  return variant === 'landingPrimary' && css(["color:", ";background-color:", ";&:hover:not(:active),&:focus{color:#5c3202;background-color:", ";}&:active{color:", ";background-color:", ";}"], theme.colors.yellow900, theme.colors.yellow500, theme.colors.yellow600, theme.colors.yellow50, theme.colors.yellow700);
}, function (_ref7) {
  var theme = _ref7.theme,
    variant = _ref7.variant,
    disabled = _ref7.disabled;
  return variant === 'primary' && disabled && css(["background-color:", ";"], theme.colors.gray600);
}, function (_ref8) {
  var theme = _ref8.theme,
    variant = _ref8.variant;
  return variant === 'secondary' && css(["color:", ";background-color:", ";&:hover:not(:active),&:focus{background-color:", ";}&:active{background-color:", ";}"], theme.colors.green900, theme.colors.green50, theme.colors.green100, theme.colors.green200);
}, function (_ref9) {
  var theme = _ref9.theme,
    variant = _ref9.variant;
  return variant === 'landingSecondary' && css(["color:", ";background-color:", ";box-shadow:0px 1px 2px rgba(0,0,0,0.1);&:hover:not(:active),&:focus{background-color:", ";}&:active{background-color:", ";}"], theme.colors.blue900, theme.colors.white, theme.colors.gray100, theme.colors.gray200);
}, function (_ref10) {
  var theme = _ref10.theme,
    variant = _ref10.variant;
  return variant === 'outlineSecondary' && css(["background-color:white;border:1px solid ", ";color:", ";&:hover:not(:active),&:focus{border:1px solid ", ";color:", ";}&:active{border:1px solid ", ";color:", ";}"], theme.colors.gray500, theme.colors.gray800, theme.colors.gray700, theme.colors.gray900, theme.colors.gray700, theme.colors.black);
}, function (_ref11) {
  var theme = _ref11.theme,
    variant = _ref11.variant,
    disabled = _ref11.disabled;
  return variant === 'outlineSecondary' && disabled && css(["background-color:", ";color:", ";border:none;box-shadow:none;"], theme.colors.gray600, theme.colors.gray900);
}, function (_ref12) {
  var theme = _ref12.theme,
    variant = _ref12.variant;
  return variant === 'outlinePrimary' && css(["background-color:white;color:", ";border:1px solid ", ";box-shadow:0px 1px 2px rgba(0,0,0,0.1);&:hover:not(:active),&:focus{color:", ";border:1px solid ", ";color:", ";}&:active{border:1px solid ", ";color:", ";}"], theme.colors.green500, theme.colors.green500, theme.colors.green700, theme.colors.green900, theme.colors.green900, theme.colors.black, theme.colors.black);
}, function (_ref13) {
  var theme = _ref13.theme,
    variant = _ref13.variant,
    disabled = _ref13.disabled;
  return variant === 'outlinePrimary' && disabled && css(["background-color:", ";color:", ";border:none;box-shadow:none;"], theme.colors.gray600, theme.colors.white);
}, function (_ref14) {
  var theme = _ref14.theme,
    variant = _ref14.variant;
  return variant === 'danger' && css(["color:white;background-color:", ";&:hover:not(:active),&:focus{background-color:", ";}&:active{background-color:", ";}"], theme.colors.red600, theme.colors.red700, theme.colors.red900);
}, function (_ref15) {
  var theme = _ref15.theme,
    variant = _ref15.variant,
    disabled = _ref15.disabled;
  return variant === 'danger' && disabled && css(["background-color:", ";"], theme.colors.gray600);
}, function (_ref16) {
  var theme = _ref16.theme,
    variant = _ref16.variant;
  return variant === 'text' && css(["color:", ";background-color:transparent;&:hover:not(:active),&:focus{background-color:", ";}&:active{background-color:", ";}"], theme.colors.green900, theme.colors.green50, theme.colors.green100);
}, function (_ref17) {
  var theme = _ref17.theme,
    variant = _ref17.variant,
    disabled = _ref17.disabled;
  return variant === 'text' && disabled && css(["color:", ";"], theme.colors.gray700);
});
var SMButton = styled(Button).withConfig({
  displayName: "StyledButton__SMButton",
  componentId: "ihk487-1"
})(["padding:0px 14px;height:32px;font-size:12px;line-height:18px;"]);
var MDButton = styled(Button).withConfig({
  displayName: "StyledButton__MDButton",
  componentId: "ihk487-2"
})(["padding:0px 16px;height:40px;font-size:14px;line-height:20px;"]);
var LGButton = styled(Button).withConfig({
  displayName: "StyledButton__LGButton",
  componentId: "ihk487-3"
})(["padding:0px 20px;height:48px;font-size:14px;line-height:23px;"]);
var XLButton = styled(Button).withConfig({
  displayName: "StyledButton__XLButton",
  componentId: "ihk487-4"
})(["padding:0px 24px;height:56px;font-size:14px;"]);
export { MDButton, SMButton, LGButton, XLButton };